import { useCallback } from "react";
import { apolloClient } from "@td/ui";
import FIND_CONSULTATION_QUERY from "../queries/find-consultation.graphql";
import { maskConsultRecord } from "../utils/masking";

const useConsultationSearch = () => {
  const findConsultation = useCallback(async (consultationId) => {
    try {
      const { data: { consultation }} = await apolloClient.query({
        query: FIND_CONSULTATION_QUERY,
        variables: {
          consultationId: parseInt(consultationId),
        },
        fetchPolicy: "network-only",
      });

      return maskConsultRecord(consultation);
    } catch (e) {
      return null;
    }
  }, [apolloClient]);

  return {
    findConsultation,
  };
};

export default useConsultationSearch;
